import i18n from 'i18n';

const trendsChartConfig = {
  chart: {
    id: 'trends-line-chart',
    toolbar: {
      show: false,
    },
    animation: {
      enabled: false,
    },
    defaultLocale: i18n.t('chart-lang'),
    locales: [
      {
        name: 'en',
        options: {
          months: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ],
          shortMonths: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
          days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          toolbar: {
            download: 'Download SVG',
            selection: 'Selection',
            selectionZoom: 'Selection Zoom',
            zoomIn: 'Zoom In',
            zoomOut: 'Zoom Out',
            pan: 'Panning',
            reset: 'Reset Zoom',
          },
        },
      },
      {
        name: 'pt-br',
        options: {
          months: [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro',
          ],
          shortMonths: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez',
          ],
          days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
          shortDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
          toolbar: {
            download: 'Baixar SVG',
            selection: 'Seleção',
            selectionZoom: 'Seleção de Zoom',
            zoomIn: 'Aproximar',
            zoomOut: 'Afastar',
            pan: 'Mover',
            reset: 'Resetar Zoom',
          },
        },
      },
    ],
  },
  xaxis: {
    type: 'date',
    tickPlacement: 'on',
    categories: [],
    labels: {
      datetimeUTC: true,
      hideOverlappingLabels: true,
      datetimeFormatter: {
        year: 'yyyy',
        month: "MMM 'yy",
        day: 'dd MMM',
        hour: 'HH:mm',
      },
      formatter: function (value) {
        return `${new Date(value).getFullYear()}-${new Date(value).getMonth() + 1}`;
      },
    },
  },
  yaxis: {
    labels: {
      show: false,
    },
    title: {
      text: i18n.t('Interest'),
      style: {
        color: '#ADB5BD',
        fontSize: '0.7rem',
        fontWeigth: '300',
      },
    },
  },
  legend: {
    show: false,
  },
  title: {
    text: '',
    align: 'left',
    offsetX: 10,
  },
  colors: ['#34C38F'],
  stroke: {
    curve: 'smooth',
    width: 2,
  },
};

export { trendsChartConfig };
